import { render, staticRenderFns } from "./ClinicalHandoutsContent.vue?vue&type=template&id=6556a507"
import script from "./ClinicalHandoutsContent.vue?vue&type=script&lang=js"
export * from "./ClinicalHandoutsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports